<div class="panel-body" id="content">
  @for (part of parsedBody; track part) {
    <div>
      @if (part.type == 'string') {
        <div [innerHTML]="part.data | safeHtml" (click)="scrollTo($event)" ></div>
      }
      @if (part.type=='form') {
        <app-forms [form]="part.data" [public]="public"></app-forms>
      }
    </div>
  }
</div>
